import { render, staticRenderFns } from "./ProjectDescriptionAside.vue?vue&type=template&id=c14a0984&lang=pug&"
import script from "./ProjectDescriptionAside.vue?vue&type=script&lang=js&"
export * from "./ProjectDescriptionAside.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDescriptionAside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports